// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, boolean, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementFilterTypeResult = objectOf({
  filter_key: string,
  display_name: string,
  varies_by_app_group: boolean,
  allowed_for_territories: boolean,
  only_for_workflow_step: boolean,
  allowed_for_predictions: boolean,
  additional_filter_data: objectOf({}),
  valid_comparisons_dictionary: objectOf({
    "1": string,
    "2": string,
    "3": string,
    "5": string,
    "11": string,
    "12": string,
  }),
  grouped_comparisons: nullOrUndefined,
  valid_values: string,
  default_value: string,
  default_comparison: number,
  is_remote: boolean,
  remote_value_count: number,
  requires_values: boolean,
  valid_values_restricted_for_look_back: boolean,
  data_type: string,
});
